import type { Mapper } from '@/core/mapper/base-mapper';
import type { GetBeraReportV2ResponseDTO } from '@/core/dto/bera';
import type { BeraReportV2Details } from '@/types/Bera';

export class GetBeraReportV2Mapper implements Mapper<BeraReportV2Details> {
	constructor(private readonly data: GetBeraReportV2ResponseDTO) {}

	toDomain(): BeraReportV2Details {
		const result: BeraReportV2Details = {
			id: this.data.id,
			task_id: this.data.task_id,
			file_id: this.data.file_id,
			bera_job_summary_id: this.data.bera_job_summary_id,
			task_time: this.data.task_time,
			task_time_format: this.data.task_time_format,
			has_known_injury: this.data.has_known_injury,
			collection_date: this.data.collection_date,
			has_no_risk: this.data.has_no_risk,
			comment: this.data.comment,
			step: this.data.step,
			reached_step: this.data.reached_step ?? this.data.step,
			consolidated: this.data.consolidated,
			segments: this.data.segments ?? [],
			step_key_results: this.data.step_key_results ?? []
		};

		return result;
	}
}
